














































import {Vue, Component, Prop} from 'vue-property-decorator'
import {SceneShot} from '@/store/shots'
import {formValidationRules} from '@/components/Shots/formsValidationRules'

@Component({
  name: "add-shot-scene-form",
})
export default class AddShotSceneForm extends Vue {
  // Note: value prop is passed from parent component using v-model
  @Prop() value!: SceneShot
  formRules = formValidationRules
}
